import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2200f002"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "area-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Spielen"),
  /*#__PURE__*/_createElementVNode("div", { class: "descr" }, "Sofort loslegen und Dinge in Bildern suchen!")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "area-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Informieren"),
  /*#__PURE__*/_createElementVNode("div", { class: "descr" }, "Mehr über Dinge in mittelalterlichen Bildwelten erfahren.")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "area-text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Aufspüren"),
  /*#__PURE__*/_createElementVNode("div", { class: "descr" }, "Dinge auf Bildern in Niederösterreich erkunden.")
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_page_header, {
            canGoBack: false,
            title: _ctx.$t('message.homePage')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      "size-xs": "12",
                      "size-sm": "12",
                      "size-md": "12",
                      "size-lg": "6"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/tagging'))),
                          class: "area",
                          id: "tagging"
                        }, _hoisted_3),
                        _createElementVNode("div", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/explore'))),
                          class: "area",
                          id: "explore"
                        }, _hoisted_5),
                        _createElementVNode("div", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/localinfo'))),
                          class: "area",
                          id: "localinfo"
                        }, _hoisted_7)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}